import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { Usd_Const, useGenerateFormFm1Mutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { Base64FileData } from 'api/types/data';
import { GenerateFormFM1Params } from 'api/types/params/generateFormFM1Param';

export const useGenerateFormFM1 = () => {
  const [handler, { data, loading, error: apolloError }] =
    useGenerateFormFm1Mutation();

  const error = useError(apolloError);

  return {
    generateFormFM1: useCallback(
      async (param: GenerateFormFM1Params, scale: number) => {
        const res = await handler({
          variables: {
            input: {
              file: param.file,
              cnyKztScale: scale,
              cnyKztValue: param.cnyKzt,
              eurKztScale: scale,
              eurKztValue: param.eurKzt,
              rubKztScale: scale,
              rubKztValue: param.rubKzt,
              usdKztScale: scale,
              usdKztValue: param.usdKzt,
              aedKztScale: scale,
              aedKztValue: param.aedKzt,
              thresholdValue: param.thresholdValue,
              currency: param.currency as Usd_Const,
              clients: param.clients.join(','),
            },
          },
        });
        return res.data?.generateFormFm1 as Base64FileData | undefined;
      },
      [handler]
    ),
    data: data?.generateFormFm1 as Base64FileData | undefined,
    loading,
    error,
  };
};
